'use client';

import { useTranslations } from 'next-intl';
import { Compass } from 'lucide-react';
import { SettingsSectionRow } from './SettingsSection';

interface ViewpointSectionProps {
  /**
   * Server-localized name of the side the constructed camera looks at
   * ("Street facade"). Null/undefined for an uploaded photo, whose camera comes
   * from the image itself.
   */
  viewpointLabel?: string | null;
}

/**
 * Which side of the building this view looks at — shown only for a CONSTRUCTED
 * view, right after Environment (both describe the setting the design is placed
 * in, as opposed to the building itself).
 *
 * Read-only on purpose: the side is fixed when the view is created
 * (`POST /projects/{id}/views` is idempotent per side), so a second side means a
 * second view, not an edit of this one. An uploaded photo has no viewpoint at
 * all — the row is hidden there rather than showing an empty or invented value.
 */
export function ViewpointSection({ viewpointLabel }: ViewpointSectionProps) {
  const t = useTranslations('render.settings.viewpoint');

  if (!viewpointLabel) return null;

  return (
    <SettingsSectionRow
      icon={Compass}
      title={t('title')}
      subtitle={viewpointLabel}
    />
  );
}
